import React, { useEffect, useState, useRef } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import CustomToastContainer from "../Common/CustomToastContainer";
import api from "../../Api";
import { useHistory } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
const domainpath = process.env.REACT_APP_DOMAIN;

const Tickets = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const history = useHistory();
  const toastRef = useRef();
  const handleDelete = async (id) => {
    const response = await api.deleteTicket(`${id}`);
    if (response.status === 200) {
      toastRef.current.addToast(response.message, "success");
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      toastRef.current.addToast(
        "There was an error deleting the Ticket!",
        "error"
      );
    }
  };

  const columns = [
    {
      name: "Ticket ID",
      selector: (row) => (
        <a
          href={`${domainpath}/dashboard/edit-ticket/${row?.sequenceNumber}`}
          className=" hover:underline"
          style={{ color: "#003366", fontSize: "14px", fontWeight: 600 }}
        >
          {row.sequenceNumber != "" &&
          row.sequenceNumber != undefined &&
          row.sequenceNumber
            ? "#" + row.sequenceNumber
            : ""}
        </a>
      ),
      sortable: true,
      width: "15%",
    },
    {
      name: "Submitted By",
      selector: (row) => row?.userId?.name,
      sortable: true,
      width: "15%",
    },
    {
      name: "Assigned To",
      selector: (row) => row?.assignedTo?.name,
      sortable: true,
      width: "15%",
    },
    {
      name: "Subject",
      selector: (row) => row.subject,
      sortable: true,
      width: "20%",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      width: "12%",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex gap-1">
          <button
            className="ViewDetails-tickets text-white px-4 py-2 rounded-full hover:text-white"
            onClick={(e) => history.push(`/dashboard/ticket/${row?._id}`)}
          >
            View Details
          </button>
          <button
            className="manage-delete-btn text-white px-6 py-2"
            onClick={() => handleDelete(row?._id)}
          >
            <FeatherIcon icon="trash" />
          </button>
        </div>
      ),
      width: "23%",
    },
  ];

  const tableData = {
    columns,
    data,
  };
  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);

        const response = await api.getTicket();
        if (response.status === 200) {
          setData(response?.tickets);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);
  return (
    <div className="p-8">
      <div className="bg-white p-4 rounded-lg shadow employer-tickets">
        <div className="flex justify-between items-center py-5">
          <h2 className="text-lg font-bold mb-4" style={{ color: "#003366" }}>
            Tickets
          </h2>
          <div className="">
            <a href="/dashboard/add-ticket">
              <button className="manage-edit-btn text-white px-3 py-2">
                Add Ticket
              </button>
            </a>
          </div>
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <DataTableExtensions {...tableData}>
            <DataTable
              columns={columns}
              data={data}
              defaultSortField="id"
              defaultSortAsc={false}
              pagination
              highlightOnHover
              className="custom-scrollbar"
            />
          </DataTableExtensions>
        )}
      </div>{" "}
      <CustomToastContainer ref={toastRef} />
    </div>
  );
};

export default Tickets;
